import { PerformanceOverviewNumbers } from '@components/performanceOverviewNumbers';
import { cn } from '@utils/helpers';
import { ArrowRightFromLineIcon } from 'lucide-react';
import { useFragment } from 'react-relay';
import { performanceOverviewInfoFragment } from './PerformanceOverviewInfo.relay';
import type { PerformanceOverviewInfoPropsType } from './types';

const PerformanceOverviewInfo: React.FC<PerformanceOverviewInfoPropsType> = (props) => {
  useFragment(performanceOverviewInfoFragment, props.data);

  let wrapperClassName = '';
  if (props.highlightLine === 1) {
    wrapperClassName = 'highlightPerformance';
  } else if (props.highlightLine === 2) {
    wrapperClassName = 'highlightBenchmark';
  }

  return (
    <div
      className={cn(
        'performanceOverviewInfoWrapper relative max-[1100px]:hidden flex flex-col justify-between h-full',
        wrapperClassName,
        props.reportCurrency,
        wrapperClassName === 'highlightPerformance' && '[&_.benchmarkWrapper]:opacity-25',
        wrapperClassName === 'highlightBenchmark' && '[&_.performanceWrapper]:opacity-25',
      )}
    >
      <ArrowRightFromLineIcon className="hover:text-accent hover:cursor-pointer h-4 w-4 mt-4.5 ml-3.5" onClick={props.toggleChartWidth} />
      <PerformanceOverviewNumbers
        data={props.data as any}
        reportCurrency={props.reportCurrency}
        currentperformance={props.currentperformance}
        currentbenchmark={props.currentbenchmark}
        paperformance={props.paperformance}
        pabenchmark={props.pabenchmark}
        onMouseEnter={props.onMouseEnter}
        onMouseLeave={props.onMouseLeave}
        language={props.language}
      />
    </div>
  );
};

export { PerformanceOverviewInfo };
